import { Box, IconButton, TextField } from "@mui/material";
import React from "react";
import BackupIcon from "@mui/icons-material/Backup";
import { secondAxios } from "../../../api/axios";

export default function StockQtyInput({
  row,
  name,
  defaultValue,
  placeholder,
  type,
}) {
  const [value, setValue] = React.useState(defaultValue || "");

  const isChanged = value !== defaultValue;

  const onChange = (e) => {
    setValue(e.target.value);
  };

  const onSubmit = async () => {
    console.log({ [name]: value });
    const res = await secondAxios.patch("/material-record", {
      mrqMaterialsIds: row?.original?.mrqMaterialsIds,
      [name]: value,
    });

    console.log({ res });
  };
  return (
    <Box
      onClick={(e) => {
        e.stopPropagation();
      }}
      sx={{ display: "flex" }}
    >
      <TextField
        hiddenLabel
        variant="standard"
        fullWidth
        sx={{ "& input": { px: 1 } }}
        value={value}
        onChange={onChange}
        size="small"
        autoComplete="off"
        type={type || "number"}
        placeholder={placeholder}
      />
      {isChanged && (
        <IconButton
          aria-label="edit"
          size="small"
          onClick={onSubmit}
          color="success"
          disabled={value === ""}
        >
          <BackupIcon />
        </IconButton>
      )}
    </Box>
  );
}
